import React, { useState } from "react";
import "./Others.css";
import { useNavigate } from "react-router-dom";

const Others = () => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedActivity, setSelectedActivity] = useState("");

  const navigate = useNavigate();

  const activitiesByCategory = {
    "Games": [
      { id: 5, title: "Puzzle Game", link: "../PuzzleGame" },
      { id: 6, title: "Invisible Snake & Ladder Game", link: "../SnakeL" },
      { id: 8, title: "Tictactoe", link: "../Tictactoe" },
      { id: 9, title: "Shoot Red Ball Game", link: "../ShootGame" },
      { id: 25, title: "Voice Games", link: "../VoiceGames" },
   { id: 39, title: "Emoji Suduko ", link: "../EmojiSuduko" },
      { id: 40, title: "Memory Game ", link: "../MemoryGame" },
      { id: 41, title: "Color Match ", link: "../ColorMatch" },
 { id: 42, title: "Shape Sorter ", link: "../ShapeSorter" },
 { id: 48, title: "Puzzle Slider ", link: "../PuzzleSlider" },
  { id: 51, title: "Emoji TicTacToe ", link: "../EmojiTicTacToe" },
    { id: 52, title: "Emoji Connect ", link: "../EmojiConnect" },
        { id: 57, title: "Emoji BoardRace", link: "../EmojiBoardRace" },
 { id: 58, title: "Maze new", link: "../Maze1" },








    ],
    "Learning": [
      { id: 10, title: "SLATE", link: "../Slate" },
      { id: 26, title: "Handwriting", link: "../Handwriting" },
      { id: 11, title: "Subtractions", link: "../Subtractions" },
      { id: 12, title: "Additions", link: "../Addition" },
      { id: 13, title: "Multiplications", link: "../Multiplications" },
      { id: 14, title: "Words Spelling", link: "../Spell" },
      { id: 17, title: "Matching", link: "../Matching" },
      { id: 29, title: "Science Basics", link: "../ScienceBasics" },
       { id: 30, title: "Money Basics", link: "../Money" },
        { id: 31, title: "Nature Basics", link: "../NatureBasics" },
         { id: 32, title: "What Helps ", link: "../WhatHelps" },
           { id: 34, title: "Learn Hindi Easily ", link: "../LessonsHindi" },
       { id: 35, title: "Life Skills ", link: "../LifeSkills" },
        { id: 36, title: "Things To Avoid ", link: "../ThingsToAvoid" },
         { id: 37, title: "Human Body explore ", link: "../HumanBody" },
      { id: 38, title: "Circuits Fundamentals ", link: "../Circuits" },
            { id: 43, title: "Maths Quiz ", link: "../MathQuizz" },
        { id: 44, title: "Trivia Quiz ", link: "../TriviaQuiz" },
       { id: 45, title: "Maths Bingo ", link: "../MathBingo" },
         { id: 46, title: "Quiz Wheel ", link: "../QuizWheel" },
      { id: 47, title: "Emoji Quiz  ", link: "../EmojiQuiz" },

    { id: 50, title: "Math-Ladder  ", link: "../MathLadder" },



    

    







    ],
    "Story Telling": [
      { id: 25, title: "Story", link: "../Story" },
      
    ],
     "Stocks Basics": [
      { id: 25, title: "Stocks Basics", link: "../StocksBasics" },
      
    ],
       "Inventions": [
      { id: 33, title: "Inventions", link: "../Inventions" },
      
    ],
     "Festivals": [
      { id: 27, title: "Festivals in India", link: "../FestivalsApp" },
      { id: 28, title: "Festivals in U.S.A", link: "../USFestivalsApp" },
      { id: 30, title: "Festivals in U.K", link: "../UKFestivalsApp" },
      
    ],
    "Creativity": [
      { id: 1, title: "Box Building", link: "../BoxBuilding" },
      { id: 3, title: "Paint Here", link: "../Paint1" },
    ],
    "Voice & Tools": [
      { id: 20, title: "Voice Calculator", link: "../VoiceCalc" },
      { id: 22, title: "Voice Time", link: "../Time" },
      { id: 60, title: "Chalk Slate", link: "../ChalkSlate" },

    ],

    "English": [
      { id: 55, title: "Word Builder", link: "../WordBuilder1" },
    { id: 56, title: "Synonym-Match", link: "../SynonymMatch" },
    { id: 62, title: "Crosswords", link: "../Crossword" },
   { id: 63, title: "Word Bingo", link: "../WordBingo" },
    { id: 64, title: "Antonym-Match", link: "../AntonymMatch" },




    ],
    "Fun Learning": [
      { id: 21, title: "Colors", link: "../Colors" },
      { id: 24, title: "Learn Fruits", link: "../Fruits" },
  { id: 49, title: "Animal Sounds", link: "../AnimalSound" },
    { id: 49, title: "Word Builder", link: "../WordBuilder" },
    { id: 61, title: "Science Lab", link: "../ScienceLab" },



        { id: 53, title: "Geography Explorer", link: "../GeographyExplorer" },


  

    ]
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setSelectedActivity("");
  };

  const handleActivityChange = (e) => {
    const selectedItem = activitiesByCategory[selectedCategory].find(
      item => item.title === e.target.value
    );
    setSelectedActivity(e.target.value);
    if (selectedItem) {
      navigate(selectedItem.link);
    }
  };

  return (
    <div className="Others">
      <h1>🎉 Kids Activities</h1>

      <div className="selector-container">
        <label htmlFor="category-select">Choose a Category:</label>
        <select id="category-select" value={selectedCategory} onChange={handleCategoryChange}>
          <option value="">-- Select a Category --</option>
          {Object.keys(activitiesByCategory).map((cat) => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
      </div>

      {selectedCategory && (
        <div className="selector-container">
          <label htmlFor="activity-select">Choose an Activity:</label>
          <select id="activity-select" value={selectedActivity} onChange={handleActivityChange}>
            <option value="">-- Select an Activity --</option>
            {activitiesByCategory[selectedCategory].map((activity) => (
              <option key={activity.id} value={activity.title}>{activity.title}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default Others;
